<template>
  <div class="content">
    
    <base-header class="pb-6" style="background-color: #248dc1 !important;">
      <div class="row align-items-center py-4">
        <div class="col-lg-7 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">{{$store.state.user.sponsor}} </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-5 col-5 text-right">
          
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" >
            <div class="form-row">
                <div class="col-md-12" > 
                    <base-input v-model="rut_autocomplete" label="Ingrese el rut del contratante:" alternative  placeholder="Ingresa un rut">
                        <autocomplete
                            :source="example"
                            input-class="form-control"
                            @input="searchVentas"
                            v-model="rut_autocomplete"
                            @clear="vacio"
                            placeholder="Ingresa un rut sin puntos y con guión"
                        >
                        </autocomplete>
                    </base-input>
                </div>
            </div>
        </card>
        <card v-show="tablaResultados" class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Listado de Planes contratados:</h3>
            <p class="text-sm mb-0">
              
            </p>
          </template>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Buscar...">
                </base-input>
              </div>
            </div>
            <div class="table-responsive">
              <el-table :data="queriedData"
                        row-key="id"
                        class="table-responsive table"
                        header-row-class-name="thead-light"
                        @sort-change="sortChange"
                        @selection-change="selectionChange">
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  v-bind="column"
                  :width="column.type == 'selection' ? '40px' : (column.label == 'id' ? '90px' : '200px')"
                >
                </el-table-column>
                <el-table-column width="180px" align="right" label="Opciones">
                  <div slot-scope="{$index, row}" class="d-flex">
                    
                      <base-button
                        v-if="true || row.estado == 'DECLARADO' || row.estado == 'SINIESTRADO'"
                        @click.native="verSiniestroPdf( row.id)"
                        class="edit"
                        type="warning"
                        size="sm"
                        icon
                      >
                      <i class="text-white far fa-file"></i> Ver formulario
                    </base-button>
                  </div>
                </el-table-column>
                <el-table-column width="180px" align="right" label="Acciones">
                  <div slot-scope="{$index, row}" class="d-flex">
                    
                    <base-button
                        @click.native="handleEdit($index, row)"
                        class="edit"
                        type="info"
                        size="sm"
                        icon
                        :disabled="row.vigencia != 'VIGENTE' || row.estado == 'SINIESTRADO AGOTADO'"
                        v-show="true || row.estado !== 'DECLARADO' "
                      >
                      <i class="text-white fa fa-arrow-right"></i> Continuar
                    </base-button>
                    
                    <!--
                    <el-tooltip content="Liquidar" placement="top">
                      <base-button @click="siniestrar(row.id, 'liquidar')" type="slack" class="btn-icon-only rounded-circle">
                          <span class="btn-inner--icon"><i class="ni ni-check-bold"></i></span>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip content="Anular" placement="top">
                      <base-button @click="siniestrar(row.id, 'anular')" type="google-plus" class="btn-icon-only rounded-circle">
                          <span class="btn-inner--icon"><i class="fas fa-ban"></i></span>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip content="Rechazar" placement="top">
                      <base-button @click="siniestrar(row.id, 'rechazar')" type="youtube" class="btn-icon-only rounded-circle">
                          <span class="btn-inner--icon"><i class="fas fa-times"></i></span>
                      </base-button>
                    </el-tooltip>
                    -->
                  </div>
                </el-table-column>
                <el-table-column width="200px" align="right" label="declaraciones">
                  <div slot-scope="{$index, row}" class="d-flex">
                    <base-button
                          @click.native="listarDeclaraciones(row.id)"
                          class="edit"
                          type="primary"
                          size="sm"
                          
                          v-show="true || row.estado !== 'DECLARADO'"
                        >
                         Listar Declaraciones
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Mostrando desde {{ from + 1 }} al {{ to }} de un total de {{ total }} registros

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} registros seleccionados
                </span>
              </p>

            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
    <formulario-siniestro @successSending="searchVentas"></formulario-siniestro>
    <siniestro-pdf></siniestro-pdf>
    <listado-siniestros></listado-siniestros>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin'
import swal from 'sweetalert2';
import { Modal, BaseAlert } from '@/components';
import Fuse from 'fuse.js';
import Autocomplete from 'vuejs-auto-complete';
import FormularioSiniestro from '@/views/Siniestros/FormularioSiniestro';
import SiniestroPdf from '@/views/Siniestros/SiniestroPdf.vue';
import ListadoSiniestros from '@/views/Siniestros/ListadoSiniestros.vue';

export default {
  mixins: [clientPaginationMixin],
  // En este mixins esta el atributo que se encarga del tamaño de la pagina
  components: {
    Autocomplete,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert,
    FormularioSiniestro,
    SiniestroPdf,
    ListadoSiniestros
  },
  data() {
    return {
      propsToSearch: ['estado', 'plan'],
      tableColumns: [
      ],
      tableData: [],
      selectedRows: [],
      rut_autocomplete: '',
      example: [],
      tablaResultados: false,
    };
  },
  methods: {
    listarDeclaraciones(venta_id){
      var vm = this;
      this.$emit('loadListaSiniestros', venta_id);
    },
    
    verSiniestroPdf(venta)
    {
        this.$emit('loadSiniestroPdf', {entity: 'venta', id: venta});
    },
    handleEdit(index, row) {
     console.log('el index es: ', index, ' y el row.id es: ', row.id);
     this.$emit('showModalFormularioSiniestro', row.id);
    },
    handleDelete(index, row) {
      swal({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: 'Deleted!',
            text: `You deleted ${row.name}`,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    fetchData()
    {
      
    },
    searchCustomer(){
        var vm = this;
        this.axios({
          url: 'api/search_customer_data?search='+this.rut_autocomplete,
          method: 'GET',
        }).then( response => {
            var vm = this;
            this.axios({
                url: 'api/test_list_materias',
                method: 'GET',
            }).then( response => {
                console.log(response.data);
                let columnas;
                if( response.data.data.length > 0 ){
                  columnas = Object.getOwnPropertyNames(response.data.data[0].data);
                } else {
                  vm.$notify({
                    message: 'No se encontraron resultados',
                    type: 'warning'
                  });
                  return;
                }
                
                vm.tableData = response.data.data.map( elem => { return { ...elem.data, atributos: elem.atributos}});
                vm.propsToSearch = columnas;
                vm.tableColumns = [];
                vm.tableColumns.push({ type: 'selection' });
                columnas.forEach( item => {
                vm.tableColumns.push({ prop: item, label: item, sortable: true });
                } );
                vm.fuseSearch = new Fuse(vm.tableData, {
                keys: vm.propsToSearch,
                threshold: 0.3
                });
                vm.tablaResultados = true;
            }).catch( error => {
                console.log('Error al ir  a buscar las materias');
                console.log(error); 
            })
          console.log(response.data);
        })
        .catch( error => {
          console.log(error);
        })
        ;
      },
      vacio()
      {
        this.tablaResultados = false;
      },
      searchVentas()
      {
        var vm = this;
        this.axios({
          url: 'api/customer_ventas_list?customer='+this.rut_autocomplete,
          method: 'GET',

        }).then( response => {
          console.log(response.data);
          let columnas;
          if( response.data.data.length > 0 ){
            columnas = Object.getOwnPropertyNames(response.data.data[0]);
          } else {
            vm.$notify({
                    message: 'No se encontraron resultados',
                    type: 'warning'
                  });
                  return;
          }
          vm.tableData = response.data.data;
          vm.propsToSearch = columnas;
          vm.tableColumns = [];
          vm.tableColumns.push({ type: 'selection' });
          columnas.forEach( item => {
          vm.tableColumns.push({ prop: item, label: item, sortable: true });
          } );
          vm.fuseSearch = new Fuse(vm.tableData, {
          keys: vm.propsToSearch,
          threshold: 0.3
          });
          vm.tablaResultados = true;
        }).catch( error => {
          console.log(error);
        });
      }
  },
  created() {
        console.log('componente creado');
        var vm = this;
        this.axios({
          url: 'api/customers_ruts_list_plans',
          method: 'get'
        })
        .then( response => {
          vm.example = response.data;
        })
        .catch( error => {
          console.log(error);
        })
        ;
  }
};
</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
</style>
